import React from 'react';
import { Dashboard, PageLayout, SideSummary } from '@components';
import { LeavingGuard } from '@components/utils/LeavingGuard';
import { BackButton, HeadContent, SaveShortcutListener } from '@fourthwall/components';
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar';
import { routing } from '@utils/routing';
import { useSingleSeriesContext } from './hooks/useSingleSeriesContext';
import { ArtworkFields } from './modules/ArtworkFields';
import { DetailsFields } from './modules/DetailsFields';
import { ThumbnailFields } from './modules/ThumbnailFields';
import { SingleSeriesProvider } from './providers/SingleSeriesProvider/SingleSeriesProvider';
export const SingleSeriesCreateComponent = () => {
    const { form, isLoading } = useSingleSeriesContext();
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Create a new video series" }),
        React.createElement(PageLayout, { leftContent: React.createElement(React.Fragment, null,
                React.createElement(DetailsFields, null),
                React.createElement(ThumbnailFields, null),
                React.createElement(ArtworkFields, null)), rightContent: React.createElement(SideSummary, null,
                React.createElement(SideSummary.Item, { title: "Video series" }, "Create a collection of selected videos, whether for a show, playlist, or series.")) },
            React.createElement(Dashboard.ItemViewHeader, { name: "Create a new video series", backButton: React.createElement(BackButton, { label: "Video series", to: routing.memberships.series.self }) })),
        React.createElement(SaveShortcutListener, { disabled: !form.dirty, onSave: form.submitForm }),
        React.createElement(ConfirmBar, { isOpen: form.dirty, isLoading: isLoading, onConfirm: form.submitForm, onCancel: form.resetForm }),
        React.createElement(LeavingGuard, { when: form.dirty, isValid: form.isValid, onSave: form.submitForm })));
};
export const SingleSeriesCreate = () => (React.createElement(SingleSeriesProvider, null,
    React.createElement(SingleSeriesCreateComponent, null)));
